import { useQuery } from 'react-query';

import { User } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetUsersInOrg = () => {
  const fetcher = useFetcher();

  return useQuery<User[]>([QueryEntity.Users], () => fetcher(`${APIBaseChronos}/api/org/users`), {
    refetchOnWindowFocus: false,
  });
};
